/** @jsxImportSource theme-ui @jsxRuntime classic */
import {
  Flex,
  IntrinsicImage,
  SanityRichText,
  Box,
  Text,
} from '@tishman/components';
import React from 'react';

import { storyComponents } from './StoryComponents';

import type { IGatsbyImageData } from 'gatsby-plugin-image';
import type { BlockContentProps } from '@sanity/block-content-to-react';

interface ImageContentsBlockProps {
  image: IGatsbyImageData;
  alt: string;
  caption?: string;
  align: string;
  blocks: BlockContentProps['blocks'];
}

export const ImageContentsBlock = ({
  image,
  alt,
  caption,
  align,
  blocks,
}: ImageContentsBlockProps): React.JSX.Element => {
  return (
    <Flex
      sx={{
        'flexDirection': [
          'column',
          null,
          align === 'left' ? 'row' : 'row-reverse',
        ],
        'my': [6, '92px'],
        'justifyContent': 'space-between',
        'alignItems': ['stretch', null, 'center'],
        '> div': { flex: ['1 1 auto', null, '0 0 48%'] },
      }}
    >
      <Box sx={{ position: 'relative', mb: 0, mx: [3, 0] }}>
        <IntrinsicImage
          alt={alt}
          image={image}
          maxWidth={550}
          ratio={1}
          sx={{ mx: 'auto' }}
        />
        {caption && (
          <Text
            sx={{
              position: 'absolute',
              fontSize: [1, 2],
              fontWeight: 'regular',
              bottom: [2, 3],
              right: [2, 3],
              color: 'mediaCaption',
              display: ['none', null, 'block'],
            }}
          >
            {caption}
          </Text>
        )}
      </Box>
      {caption && (
        <Box
          sx={{
            margin: ['0 16px', '0 auto'],
            mt: '12px',
            mb: 4,
            display: ['block', null, 'none'],
          }}
        >
          <Text
            sx={{
              fontSize: [1, 2],
              color: 'black',
              fontStyle: 'italic',
            }}
          >
            {caption}
          </Text>
        </Box>
      )}
      <SanityRichText blocks={blocks} components={storyComponents} />
    </Flex>
  );
};
